module.exports = __webpack_public_path__ + "static/media/unknown_trim.4c0454ad.png";